import { render } from "./PurgeWarning.vue?vue&type=template&id=6041f27c&ts=true"
import script from "./PurgeWarning.vue?vue&type=script&lang=ts"
export * from "./PurgeWarning.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__